module.exports = __webpack_public_path__ + "assets/media/sound6.a7bb8a3f.mp3";